// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__38Ztw","copy":"styles_copy__IKXB0","home":"styles_home__2P03Q"};